<template>
  <v-main>
    <div class="dash">
      <div class="dash__head">
        <h1 class="dash__title">Dashboard</h1>
        <p class="dash__sub">Training overview at a glance</p>
      </div>

      <!-- KPI cards -->
      <SaCounts />

      <!-- charts -->
      <v-row class="mt-2">
        <v-col cols="12" md="7">
          <v-card class="dash__panel" elevation="0">
            <div class="dash__panel-title">Overview</div>
            <div id="barChart"></div>
          </v-card>
        </v-col>
        <v-col cols="12" md="5">
          <v-card class="dash__panel" elevation="0">
            <div class="dash__panel-title">Composition</div>
            <div id="donutChart"></div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import SaCounts from "./dashboardcount.vue";
import ApexCharts from "apexcharts";
import axios from "axios";

export default {
  name: "HomePage",
  data() {
    return {
      isLoading: false,
      roleId: "",
      counts: {},
      barChart: null,
      donutChart: null,
    };
  },
  components: {
    SaCounts,
  },
  async mounted() {
    this.roleId = this.user.roles[0].id;
    await this.getData();
    this.renderCharts();
  },
  beforeDestroy() {
    if (this.barChart) this.barChart.destroy();
    if (this.donutChart) this.donutChart.destroy();
  },
  methods: {
    n(v) {
      const x = Number(v);
      return isNaN(x) ? 0 : x;
    },
    async getData() {
      try {
        let response = await axios.get(`/admin_dashboard`);
        this.counts = response.data || {};
      } catch (e) {
        console.error("Dashboard data error:", e);
        this.counts = {};
      }
    },
    renderCharts() {
      const candidates = this.n(this.counts.totalUser);
      const teachers = this.n(this.counts.totalTeacher);
      const courses = this.n(this.counts.totalCourse);
      const completed = this.n(this.counts.totalCourseCompletedCandidate);

      const NAVY = "#0C3A5B", TEAL = "#0E8390", BRASS = "#D69A34", GREEN = "#2E8B6F", INK = "#132430", MIST = "#61798a";
      const font = "Segoe UI, system-ui, sans-serif";

      // ---- horizontal bar: readable even when Completed dwarfs the rest ----
      const barEl = document.querySelector("#barChart");
      if (barEl) {
        this.barChart = new ApexCharts(barEl, {
          chart: { type: "bar", height: 320, toolbar: { show: false }, fontFamily: font },
          series: [{ name: "Count", data: [candidates, teachers, courses, completed] }],
          colors: [TEAL, NAVY, BRASS, GREEN],
          plotOptions: { bar: { horizontal: true, distributed: true, borderRadius: 6, barHeight: "58%" } },
          dataLabels: { enabled: true, style: { colors: [INK], fontWeight: 700, fontSize: "13px" } },
          xaxis: {
            categories: ["Candidates", "Teachers", "Courses", "Completed"],
            labels: { style: { colors: MIST, fontWeight: 600 } },
          },
          yaxis: { labels: { style: { colors: INK, fontWeight: 600 } } },
          legend: { show: false },
          grid: { borderColor: "#eef2f4" },
          tooltip: { y: { formatter: (v) => Number(v).toLocaleString() } },
        });
        this.barChart.render();
      }

      // ---- donut: system composition ----
      const donutEl = document.querySelector("#donutChart");
      if (donutEl) {
        this.donutChart = new ApexCharts(donutEl, {
          chart: { type: "donut", height: 320, fontFamily: font },
          series: [candidates, teachers, courses],
          labels: ["Candidates", "Teachers", "Courses"],
          colors: [TEAL, NAVY, BRASS],
          stroke: { width: 2, colors: ["#ffffff"] },
          dataLabels: { enabled: true, style: { fontWeight: 700 } },
          legend: { position: "bottom", labels: { colors: INK }, fontWeight: 600 },
          plotOptions: {
            pie: {
              donut: {
                size: "62%",
                labels: {
                  show: true,
                  total: { show: true, label: "Total", color: NAVY, formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0).toLocaleString() },
                },
              },
            },
          },
        });
        this.donutChart.render();
      }
    },
  },
};
</script>

<style scoped>
.dash { padding: 24px 28px 40px; }
.dash__head { margin-bottom: 18px; }
.dash__title {
  font-family: 'Bahnschrift', 'Segoe UI', system-ui, sans-serif;
  font-size: 1.9rem;
  font-weight: 700;
  color: #0c3a5b;
  margin: 0;
}
.dash__sub { color: #61798a; margin: 2px 0 0; font-size: 0.92rem; }

.dash__panel {
  border: 1px solid #dbe3e8;
  border-radius: 14px !important;
  padding: 18px 20px;
  background: #ffffff;
  height: 100%;
}
.dash__panel-title {
  font-family: 'Bahnschrift', 'Segoe UI', system-ui, sans-serif;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-size: 0.82rem;
  color: #0c3a5b;
  margin-bottom: 6px;
}
</style>
